// import all custom controllers

import ControllerButton from '../../components/atoms/a-button/a-button.controller';
import ControllerNavbar from '../../components/molecules/m-kb-navbar/m-kb-navbar.controller';
import ControllerKbStartpageStage from '../../components/organisms/o-kb-startpage-stage/o-kb-startpage-stage.controller';
import ControllerPdfListToolbar from '../../components/molecules/m-pdf-list-toolbar/m-pdf-list-toolbar.controller';
import ControllerPdfSearchHeader from '../../components/organisms/o-pdf-search-header/o-pdf-search-header.controller';
import ControllerAccordion from '../../components/organisms/o-accordion/o-accordion.controller';
import ControllerProductTeaser from '../../components/molecules/m-teaser-product/m-teaser-product.controller';
import ControllerSearchFilter from '../../components/molecules/m-searchfilter/m-searchfilter.controller';
import ControllerQuantitySelector from '../../components/atoms/a-quantity-selector/a-quantity-selector.controller';
import ControllerBreadcrumbDynamic from '../../components/molecules/m-breadcrumb-dynamic/m-breadcrumb-dynamic.controller';
import ControllerShoppingCart from '../../components/organisms/o-shopping-cart/o-shopping-cart.controller';
import ControllerShopFilterStage from '../../components/organisms/o-shop-filter-stage/o-shop-filter-stage.controller';
import ControllerVideo from '../../components/organisms/o-video/o-video.controller';
import ControllerProductList from '../../components/organisms/o-product-list/o-product-list.controller';
import ControllerProductDetails from '../../components/organisms/o-product-details/o-product-details.controller';
import ControllerTeaserListItem from '../../components/molecules/m-teaser-list-item/m-teaser-list-item.controller';
import ControllerIndexNav from '../../components/molecules/m-article-index-nav/m-article-index-nav.controller';
import ControllerOffcanvas from '../../components/molecules/m-nav-offcanvas/m-nav-offcanvas.controller';
import ControllerGridContainer from '../../components/organisms/o-grid-container/o-grid-container.controller';
import ControllerLoginForm from '../../components/molecules/m-login-form/m-login-form.controller';
import ControllerSelectIcon from '../../components/molecules/m-formstep-select-icon/m-formstep-select-icon.controller';
import ControllerFormstepPersonalData from '../../components/molecules/m-formstep-personal-data/m-formstep-personal-data.controller';
import ControllerFormstepSelectImage from '../../components/molecules/m-formstep-select-image/m-formstep-select-image.controller';
import ControllerPagination from '../../components/molecules/m-pagination/m-pagination.controller';
import ControllerProductInfo from '../../components/organisms/o-product-info/o-product-info.controller';
import ControllerTableContents from '../../components/molecules/m-table-contents/m-table-contents.controller';
import ControllerTeaserGrid from '../../components/organisms/o-teaser-grid/o-teaser-grid.controller';
import ControllerTeaserRow from '../../components/organisms/o-teaser-row/o-teaser-row.controller';
import ControllerFHWSearch from '../../components/organisms/o-fhw-search/o-fhw-search.controller';
import ControllerFhwProfileJumpToSection from '../../components/molecules/m-fhw-profile-jump-to-section/m-fhw-profile-jump-to-section.controller';
import ControllerProfileSliders from '../../components/molecules/m-fhw-profile-sliders/m-fhw-profile-sliders.controller';
import ControllerAdviser from '../../components/organisms/o-adviser/o-adviser.controller';
import ControllerSearchField from '../../components/molecules/m-search-field/m-search-field.controller';
import ControllerFinder from '../../components/organisms/o-finder/o-finder.controller';
import ControllerFinderSelectStep from '../../components/molecules/m-finder-select-step/m-finder-select-step.controller';
import ControllerProfessionalProductTableDesktop from '../../components/molecules/m-professional-product-table-desktop/m-professional-product-table-desktop.controller';
import ControllerProfessionalProductTableMobile from '../../components/molecules/m-professional-product-table-mobile/m-professional-product-table-mobile.controller';
import ControllerProfessionalAnchorNavigation from '../../components/molecules/m-professional-anchor-navigation/m-professional-anchor-navigation.controller';
import ControllerProductGallery360 from '../../components/organisms/o-product-gallery-360/o-product-gallery-360.controller';
import ControllerProductGallery from '../../components/molecules/m-product-gallery/m-product-gallery.controller';
import ControllerNavigation from '../../components/molecules/m-nav-bar/m-nav-bar.controller';
import ControllerHeroContactSelector from '../../components/molecules/m-hero-contact-selector/m-hero-contact-selector.controller';
import ControllerTabbedContent from "../../components/organisms/o-tabbed-content/o-tabbed-content.controller";
import ControllerPlayButton from '../../components/atoms/a-play-button/a-play-button.controller';
import ControllerVideoOverlay from '../../components/molecules/m-video-overlay/m-video-overlay.controller';
import ControllerMarkerImage from "../../components/molecules/m-marker-image/m-marker-image.controller"
import ControllerFinderPopupForm from "../../components/molecules/m-finder-popup-form/m-finder-popup-form.controller"
import ControllerTeaserRowStaggered from "../../components/organisms/o-teaser-single-row-staggered/o-teaser-single-row-staggered.controller";
import ControllerFormSteps from "../../components/organisms/o-form-stepper/o-form-stepper.controller";
import ControllerJobOffers from '../../components/organisms/o-job-offers/o-job-offers.controller'
import ControllerJobOfferArea from '../../components/molecules/m-job-offer-area/m-job-offer-area.controller';
import ControllerJobOfferSearch from '../../components/molecules/m-job-offer-search/m-job-offer-search.controller';
import ControllerFabButton from '../../components/atoms/a-fab-button/a-fab-button.controller';
import ControllerFabMenu from '../../components/organisms/o-fab-menu/o-fab-menu.controller';
import ControllerSystemComponent from '../../components/molecules/m-formstep-system-component/m-formstep-system-component.controller'
import ControllerFormStepResumeSlice from '../../components/molecules/m-formstep-resume-slice/m-formstep-resume-slice.controller'
import ControllerFormstepWarrantyWolfProducts from '../../components/molecules/m-formstep-warranty-wolf-products/m-formstep-warranty-wolf-products.controller'
import ControllerProductGalleryDetails from '../../components/molecules/m-product-gallery-details/m-product-gallery-details.controller';
import ControllerFhwContactForm from '../../components/molecules/m-fhw-contact-form/m-fhw-contact-form.controller';
import ControllerInputSearchFat from '../../components/molecules/m-input-search-fat/m-input-search-fat.controller';
import ControllerSearchResults from "../../components/organisms/o-search-results/o-search-results.controller";
import ControllerControlledForm from '../../components/molecules/m-form/m-form.controller';
import ControllerFormstepWarrantyStep2 from '../../components/molecules/m-formstep-warranty-step-2/m-formstep-warranty-step-2.controller';
import ControllerFormstepWarrantyStep3 from '../../components/molecules/m-formstep-warranty-step-3/m-formstep-warranty-step-3.controller';
import ControllerFormstepResumeStep from '../../components/molecules/m-formstep-resume-step/m-formstep-resume-step-controller';
import ControllerToggleSearchCategory from '../../components/molecules/m-category-toggle-selector/m-category-toggle-selector.controller';
import ControllerSearchAutoSuggestionResults from '../../components/molecules/m-search-autosuggestion-hits/m-search-autosuggestion-hits.controller';
import ControllerSearchInputDebounce from '../../components/molecules/m-input-search-debounce/m-input-search-debounce.controller';
import ControllerSearchFlyout from '../../components/molecules/m-search-flyout/m-search-flyout.controller';
import ControllerHeatingForm from '../../components/organisms/o-heating-form/o-heating-form.controller';
import ControllerDownload from '../../components/molecules/m-download/m-download.controller';
import ControllerServiceOrderBookingForm from '../../components/organisms/o-service-order-booking-form/o-service-order-booking-form.controller';
import ControllerButtonsGroup from '../../components/molecules/m-button-group/m-button-group.controller';
import ControllerImageGalleryModal from '../../components/molecules/m-image-gallery/m-image-gallery.controller';
import ControllerDownloadList from '../../components/organisms/o-download-list/o-download-list.controller';
import ControllerAccordionFilter from '../../components/molecules/m-filter-accordion/m-filter-accordion.controller';
import ControllerDateRange from '../../components/molecules/m-date-range/m-date-range.controller';
import ControllerMediacenterList from '../../components/organisms/o-mediacenter-list/o-mediacenter-list.controller';
import ControllerFhwProfileHeader from "../../components/molecules/m-fhw-profile-header/m-fhw-profile-header.controller";
import ControllerPressHeadline from '../../components/molecules/m-press-headline/m-press-headline.controller';
import ControllerAhuRequest from "../../components/molecules/m-ahu-request/m-ahu-request.controller";
import ControllerAhuRequestKontakt from "../../components/molecules/m-ahu-request/m-ahu-request-kontakt.controller";
import FooterController from '../../components/molecules/m-ahu-footer/m-ahu-footer.controller';
import ControllerRedirectModal from "../../components/molecules/m-redirect-modal/m-redirect-modal.controller";
import ControllerDatePicker from "../../components/atoms/a-datepicker/a-datepicker.controller";



/**'
/**
 * Export available controller classes like this
 * import ControllerIcon from '../../../global/js/ControllerIcon';
 * export default {
 *     ControllerIcon,
 *     ...,
 * };
 */
export default {
	ControllerButton,
	ControllerNavbar,
	ControllerKbStartpageStage,
	ControllerPdfListToolbar,
	ControllerPdfSearchHeader,
	ControllerProductTeaser,
	ControllerQuantitySelector,
	ControllerShoppingCart,
	ControllerShopFilterStage,
	ControllerBreadcrumbDynamic,
	ControllerSearchFilter,
	ControllerVideo,
	ControllerAccordion,
	ControllerProductList,
	ControllerProductDetails,
	ControllerTeaserListItem,
	ControllerIndexNav,
	ControllerOffcanvas,
	ControllerGridContainer,
	ControllerLoginForm,
	ControllerSelectIcon,
	ControllerFormstepPersonalData,
	ControllerFormstepSelectImage,
	ControllerPagination,
	ControllerProductInfo,
	ControllerTableContents,
	ControllerTeaserGrid,
	ControllerTeaserRow,
	ControllerFHWSearch,
	ControllerFhwProfileJumpToSection,
	ControllerProfileSliders,
	ControllerAdviser,
	ControllerSearchField,
	ControllerFinder,
	ControllerFinderSelectStep,
	ControllerProductGallery360,
	ControllerProductGallery,
	ControllerProfessionalProductTableDesktop,
	ControllerProfessionalProductTableMobile,
	ControllerProfessionalAnchorNavigation,
	ControllerNavigation,
	ControllerTabbedContent,
	ControllerPlayButton,
	ControllerMarkerImage,
	ControllerHeroContactSelector,
	ControllerVideoOverlay,
	ControllerFinderPopupForm,
	ControllerAhuRequest,
	ControllerAhuRequestKontakt,
	ControllerTeaserRowStaggered,
	ControllerFormSteps,
	ControllerJobOffers,
	ControllerJobOfferArea,
	ControllerJobOfferSearch,
	ControllerFabButton,
	ControllerFabMenu,
	ControllerSystemComponent,
	ControllerFormStepResumeSlice,
	ControllerFormstepWarrantyWolfProducts,
	ControllerProductGalleryDetails,
	ControllerFhwContactForm,
	ControllerInputSearchFat,
	ControllerSearchResults,
	ControllerControlledForm,
	ControllerFormstepWarrantyStep2,
	ControllerFormstepWarrantyStep3,
	ControllerFormstepResumeStep,
	ControllerToggleSearchCategory,
	ControllerSearchAutoSuggestionResults,
	ControllerSearchInputDebounce,
	ControllerSearchFlyout,
	ControllerHeatingForm,
	ControllerDownload,
	ControllerServiceOrderBookingForm,
	ControllerButtonsGroup,
	ControllerImageGalleryModal,
	ControllerDownloadList,
	ControllerAccordionFilter,
	ControllerDateRange,
	ControllerMediacenterList,
	ControllerPressHeadline,
	ControllerFhwProfileHeader,
	ControllerRedirectModal,
	FooterController,
	ControllerDatePicker
};
